import { action, observable, toJS } from 'mobx';
import { makeFetchRequest } from '../utils/API';


class PostStore {
  @observable post = null;
  @observable counter = 0;
  @observable prevPage = [];
  @observable currentPage = '';
  @observable listForDetail = {};
  // {
  //   '277a0619-f1f3-4b10-9fb2-0170457a9c93': { array: [], nextPageUrl: '', index: 0 },
  //   '48615e44-7bfd-46bc-8778-bc5e78ab929d': [],
  // }


  endpoint = 'posts';

  constructor(initialData = {}) {
    this.post = initialData.post;
    this.counter = initialData.counter || 0;
    this.prevPage = initialData.prevPage || [];
    this.currentPage = initialData.currentPage || '';
    this.listForDetail = initialData.listForDetail || {};
  }

  async fetch(id) {
    const response = await makeFetchRequest(`${this.endpoint}/${id}`);
    console.log("response", response)
    this.setPost(response);
  }

  async incrementCount() {
    this.increment();
  }

  @action setPost(post) {
    this.post = post;
  }

  @action increment() {
    this.counter = this.counter + 1;
    console.log("INcrement ACtion", this.counter)
  }

  @action updateCurrentPage(currentPage) {
    this.currentPage && this.prevPage.push(this.currentPage);
    this.currentPage = currentPage;
  }

  @action updateSwipableList(feed, id, nextPageUrl, index, overwriteArray = true) {
    this.listForDetail[id] = { feed: feed, nextPageUrl: nextPageUrl, index: index };
  }

  @action getSwipableList(id) {
    // flow_id
    let listForDetail = toJS(this.listForDetail);
    console.log("ITEMS", listForDetail[id], listForDetail, id)
    return toJS(listForDetail[id]);
  }
}

export default PostStore;
